module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 151.46 70.16"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_2",
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_4",
      "data-name": "Layer 4"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M116.6,0H36.86a35,35,0,0,1,0,69.72H116.6a34.86,34.86,0,0,0,34.86-34.86h0A34.86,34.86,0,0,0,116.6,0Z",
      "fill": "#d7d8d6"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "34.86",
      "cy": "35.31",
      "r": "34.86",
      "fill": "#515151"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('circle', {
    attrs: {
      "cx": "34.86",
      "cy": "35.31",
      "r": "23.63",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.57,28.63c1.56-9.8,6.47-17,12.29-17,3.1,0,6,2,8.16,5.43",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47.31,29.76a43.4,43.4,0,0,1,.35,5.55c0,13-5.73,23.63-12.8,23.63-5.82,0-10.73-7.16-12.29-17",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40.94,45.84a23.77,23.77,0,0,1,11.46,5.3",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.32,51.14a23.76,23.76,0,0,1,11.47-5.3",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.06,20.57c.47-.35.92-.72,1.34-1.1",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.32,19.47c3.93,3.56,10.32,5.87,17.54,5.87a32.35,32.35,0,0,0,5-.38",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "28.07",
      "y1": "35.31",
      "x2": "58.49",
      "y2": "35.31",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "11.23",
      "y1": "35.31",
      "x2": "16.26",
      "y2": "35.31",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.86",
      "y1": "38.84",
      "x2": "34.86",
      "y2": "11.67",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "34.86",
      "y1": "58.94",
      "x2": "34.86",
      "y2": "51.65",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "45.91",
      "cy": "23.36",
      "r": "4.09",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "22.05",
      "cy": "35.31",
      "r": "4.09",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39,45.27a4.09,4.09,0,1,1-4.09-4.09A4.09,4.09,0,0,1,39,45.27Z",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.81"
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab50cd36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/MarketIconWithBackground.vue
// module id = 3342
// module chunks = 0